module.exports = __webpack_public_path__ + "img/login-bg2.38931f65.png";